import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
export const CountryFlag = React.memo(function CountryFlag({ countryCode, square, ...rest }) {
    const { $t } = useIntl();
    const c = countryCode ?? 'NEU';
    const p = square ? `square/${c}` : c;
    return (_jsx("img", { src: `https://r2cdn.perplexity.ai/images/country_flags/${p}.svg`, alt: $t({
            defaultMessage: '{code} flag',
            id: 'e4f9e40f5e',
            description: 'Alt text for a country flag image in the Country Flag shared UI section',
        }, { code: countryCode ?? 'NEU' }), ...rest }));
});
//# sourceMappingURL=CountryFlag.js.map